import intl from 'react-intl-universal'
import React, { useEffect } from 'react'
import {
  Console,
  HeaderButton,
  UserAvatar,
  UserInfoItem,
  UserItem,
  UserItemsWrapper,
  UserMenuWrapper,
} from './atoms'
import { useRef, useState } from 'react'
import { LOCALE } from '@foxrenderfarm/internals'
import { API, baseTaskUrl, getRegisterLink, isTestUrl } from '../../utils'
import { UserAuthorizationService } from '../../service'
import { DownArrowIcon } from './svg'
import { useClickAway } from '../../hooks'
import axios from 'axios'

const userItems = [
  {
    title: 'index.header.myJobs',
    href: 'https://task.foxrenderfarm.com/render',
  },
  {
    title: 'index.header.recharge',
    href: 'https://account.foxrenderfarm.com/center/user/topUp',
  },
  {
    title: 'index.header.billing',
    href: 'https://task.foxrenderfarm.com/user/consumption',
  },
  {
    title: 'index.header.profile',
    href: 'https://task.foxrenderfarm.com/user/profile',
  },
]

interface Props {
  locale: LOCALE
}

export const UserStatus = ({ locale }: Props) => {
  const userMenuWrapRef = useRef<HTMLDivElement | null>(null)
  const [showMenu, setShowMenu] = useState(false)
  const [signinUrl, setSigninUrl] = useState('https://task.foxrenderfarm.com/sso/signin')
  const [signupUrl, setSignupUrl] = useState('https://task.foxrenderfarm.com/sso/signup')
  const [isLogined, setIsLogined] = useState(UserAuthorizationService.isLogined())
  const [userName, setUserName] = useState(UserAuthorizationService.getUserName())

  useClickAway(userMenuWrapRef, () => {
    userMenuWrapRef && setShowMenu(false)
  })

  const getLinkQuery = () => {
    const linkQueries = {
      [LOCALE.KR]: '&key=6hsP2oc4EiIX2533',
    }
    const query = linkQueries?.[locale as LOCALE.KR]
    return typeof query === 'undefined' ? '' : query
  }

  const handleLogout = () => {
    const instance = axios.create({
      withCredentials: true,
      baseURL:
        process.env.NODE_ENV === 'development'
          ? '/'
          : isTestUrl()
            ? API.auth.testHost
            : API.auth.host,
    })
    instance
      .post('/api/rendering/user/userLogout', {
        raySyncUserKey: '',
      })
      .then((res) => {
        if (res.data.code === 200) {
          UserAuthorizationService.removeUserName()
          UserAuthorizationService.removeUserId()
          if (typeof window !== 'undefined') {
            window.location.reload()
          }
        }
      })
  }

  useEffect(() => {
    setSigninUrl(`${baseTaskUrl()}/sso/signin`)
    setSignupUrl(getRegisterLink(locale, getLinkQuery()))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const handleLoginStatusChange = () => {
      setIsLogined(UserAuthorizationService.isLogined())
      setUserName(UserAuthorizationService.getUserName())
    }

    const unsubscribe = UserAuthorizationService.subscribe(handleLoginStatusChange)

    return unsubscribe
  }, [])

  return isLogined ? (
    <>
      <Console href='https://task.foxrenderfarm.com' className='console-link'>
        {intl.get('index.header.console')}
      </Console>
      <UserMenuWrapper ref={userMenuWrapRef} $show={showMenu}>
        <UserInfoItem
          className='header-user-info-item'
          $show={showMenu}
          onClick={() => setShowMenu(!showMenu)}
        >
          <UserAvatar>{userName.substring(0, 1)}</UserAvatar>
          {userName}
          <DownArrowIcon />
        </UserInfoItem>
        <UserItemsWrapper $show={showMenu}>
          {userItems.map((item, index) => (
            <UserItem as='a' key={index} href={item.href}>
              {intl.get(item.title)}
            </UserItem>
          ))}
          <UserItem onClick={handleLogout}>{intl.get('index.header.logout')}</UserItem>
        </UserItemsWrapper>
      </UserMenuWrapper>
    </>
  ) : (
    <>
      <HeaderButton as='a' id='index_sign_in' href={signinUrl} $horizontalPadding={17} $height={36}>
        {intl.get('index.header.signIn')}
      </HeaderButton>
      <HeaderButton
        $isRegister
        as='a'
        id='index_register'
        href={signupUrl}
        $horizontalPadding={14}
        $height={36}
      >
        {intl.get('index.header.register')}
      </HeaderButton>
    </>
  )
}
